module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/hoodie/4-2-16a9c30019fdae80aa28fdf68d8da51d.jpg";